module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0087.jpg?v=efcbd16f";